export class TaxSummaryHeader {
  taxSummaryHeaderId!: number;
  name!: string;
}
